import { Button, Checkbox, Collapse, Drawer, Image, Modal, Space } from 'antd';
import styled from 'styled-components';
import { white, black } from '../../../styles/colors';

interface FilterTipContainerProps {
    yTranslation?: string;
}

export const ModalWrapper = styled(Modal)`
    margin-left: 0;
    width: 680px !important;

    .ant-modal-body {
        padding: 40px;
    }
`;

export const DrawerWrapper = styled(Drawer)`
    .ant-drawer-body {
        background-color: white;
        padding: 40px 16px 40px 99px;
    }
`;

export const DrawerHeader = styled.div`
    display: flex;
    align-items: end;
    gap: 12px;
`;

export const DrawerTitle = styled.span`
    font-family: 'DINNextLTPro';
    font-size: 24px;
    line-height: 24px;
    color: #00273b;
`;

export const CloseButton = styled.div`
    position: absolute;
    top: 12px;
    right: 12px;
    cursor: pointer;
`;

export const ButtonsGroup = styled.div`
    display: flex;
    justify-content: end;
    gap: 10px;
    margin-top: 8px;
`;

export const ProductsFiltersGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-top: 8px;
`;

export const FilterSubcategoryTitle = styled.div`
    font-family: 'Proxima N W15 Bold';
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    display: flex;
    gap: 8px;
    align-items: center;
`;

export const ClearAllButton = styled(Button)`
    font-family: 'Proxima Nova';
    font-size: 12px;
    line-height: 14px;
    color: #134fbd;
    padding: 0;

    &:hover {
        color: #134fbd;
    }
`;

export const CollapseWrapper = styled(Collapse)`
    border: 0;
    background-color: ${white} !important;
    .ant-collapse-header {
        padding: 0 !important;
        background-color: ${white};
        display: flex;

        .ant-collapse-header-text {
            font-family: 'Proxima N W15 Bold';
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
        }

        .ant-collapse-expand-icon {
            height: 20px;
        }

        .switch-mesh {
            width: 36px;
            height: 20px;
        }

        .switch-container {
            height: 20px;
        }

        &:hover {
            color: #134fbd;

            .switch-button {
                background-color: #134fbd;
                border-color: #134fbd;

                &:before {
                    background-color: ${white};
                }

                &:after {
                    background-color: ${white};
                }
            }
        }
    }

    .ant-collapse-item {
        border: 0;
        padding: 16px 0px 16px 0px;
    }

    .ant-collapse-content {
        border: 0;
    }

    .ant-collapse-content-box {
        padding: 0;
        padding-left: 36px;
    }
`;

export const CheckboxWrapper = styled(Checkbox)`
    margin-left: 0 !important;
`;

export const SubCheckboxWrapper = styled(Checkbox)`
    margin-left: 24px !important;
`;

export const FilterTitleWrapper = styled.div`
    background-color: ${white};
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
    align-items: start;
    flex-wrap: wrap;
`;

export const FilterImageWrapper = styled.div`
    display: flex;
    gap: 4px;

    .ant-image-error {
        display: none;
    }

    .ant-image-img {
        vertical-align: top;
    }
`;

export const FiltersTipContainer = styled('span')<FilterTipContainerProps>`
    text-transform: initial;
    white-space: normal;
    background: url(src/assets/images/icon-tooltip_darker.svg) no-repeat 0 0;
    background-size: 13px 13px;
    float: right;
    height: 13px;
    width: 13px;
    cursor: pointer;

    .ant-image {
        display: flex;
    }
    img {
        cursor: pointer;
    }
    .program-tip {
        display: none;
        &:hover {
            display: block;
        }
    }

    &:hover {
        .program-tip,
        .tooltip-ec3,
        .filters-tooltip-hpd {
            transform: translate(0, ${(props) => props.yTranslation || '0'});
            z-index: 99999999;
            display: block;
            border-radius: 3px;
            background: #ffffb8;
            position: absolute;
            color: ${black};
        }

        .filters-tooltip-hpd {
            top: -300px;
            left: 14px;
            position: absolute;
        }

        .tooltip-ec3 {
            min-width: 718px !important;
            border: 1px solid grey;
            box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.5);
            top: -300px;
            left: 15px;
            position: absolute;
        }

        .shadow {
            border: 1px solid grey;
            box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.5);
        }
    }
`;

export const HPDTitleWrapper = styled.div`
    display: flex;
    align-items: flex-end;

    .hpd-tooltip-container {
        margin-bottom: 5px;
        margin-left: 5px;
    }
`;

export const ImpactAreaIconWrapper = styled.span`
    display: block;
    width: 14px;
    height: 14px;

    &.ant-image-error {
        display: none;
    }

    &.ant-image-img {
        vertical-align: top;
    }

    &:hover .impact-area-tooltip {
        opacity: 1;
        display: block;
    }
`;

export const ImpactAreaIconTooltip = styled('div')<FilterTipContainerProps>`
    transform: translate(0, ${(props) => props.yTranslation || '0'});
    position: absolute;
    padding: 2px 6px;
    font-size: 10px;
    line-height: 14px;
    background: #ffffb8;
    border: 1px solid #ccc;
    box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.2);
    border-radius: 3px;
    z-index: 99999;
    opacity: 0;
    display: none;
    transition: visibility linear 0.3s, opacity 0.3s linear;
    pointer-events: none;
    white-space: nowrap;
`;

export const CollapseHeaderText = styled.div`
    font-family: 'Proxima N W15 Bold';
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
`;

export const LowEmmittingCollapseSubHeaderText = styled.div`
    font-size: 12px;
    line-height: 15px;
    font-family: Proxima Nova, Arial, Helvetica Neue, Helvetica, sans-serif;
    color: ${black};
    pointer-events: none;
    &:hover {
        color: ${black};
    }
`;

export const LowEmmittingHeaderWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
`;

export const FilterTitle = styled.div`
    font-family: 'Proxima N W15 Bold';
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    display: flex;
    gap: 8px;
    align-items: center;
`;

export const FilterContainer = styled(Space)`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .ant-space-item:last-child {
        width: 130px;
        button {
            width: 100%;
        }
    }
    .ant-select:last-child {
        width: 130px;
    }
`;
